import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { Plus, Trash2, Calendar } from 'lucide-react'
import './NewCourtPricing.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import Swal from 'sweetalert2';
import axios from 'axios'

const CourtPricing = () => {
  const [pricingType, setPricingType] = useState('')
  const [fromDay, setFromDay] = useState('')
  const [toDay, setToDay] = useState('')
  const [singleDay, setSingleDay] = useState('')
  const navigate = useNavigate();
  const [timeSlots, setTimeSlots] = useState([
    { startTime: '', endTime: '', price: '' }
  ])

  const { selectedCenter } = useUser();
  const token = localStorage.getItem('auth-token');
  const location = useLocation();
  const { academyId, courtTypeId, sportId, fromDays, toDays } = location.state || {}
  const [isEditMode, setIsEditMode] = useState(false);
  const [originalId, setOriginalId] = useState(null);
  const [dayRangeId, setDayRangeId] = useState(null); // Add dayRangeId state

  const daysOfWeek = [
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' },
    { value: 'sunday', label: 'Sunday' }
  ]
  const [selectedSport, setSelectedSport] = useState();
  const [selectedCourt, setSelectedCourt] = useState();

  const [sports, setSports] = useState([]);
  const [courtType, setCourtType] = useState([]);

  useEffect(() => {
    if (!academyId || !courtTypeId || !sportId) return;
    const fetchPricingData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_COURT_NEW_PRICE_LIST}?academyId=${academyId}&sportId=${sportId}&courtTypeId=${courtTypeId}&fromDay=${fromDays}&toDay=${toDays}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            }
          }
        );

        if (response.data.success && response.data.data.data.sports.length > 0) {
          const sportData = response.data.data.data.sports[0];
          const courtTypeData = sportData.courtTypes[0];

          const allTimeSlots = courtTypeData.timeRanges.map(pricingData => ({
            originalId: pricingData.originalId,
            startTime: pricingData.startTime.slice(0, 5),
            endTime: pricingData.endTime.slice(0, 5),
            price: pricingData.hourlyPricing.toString()
          }));
          console.log("Time slots", allTimeSlots);
          setTimeSlots(allTimeSlots);

          if (courtTypeData.timeRanges.length > 0) {
            const pricingData = courtTypeData.timeRanges[0];
            setOriginalId(pricingData.originalId);

            // Set dayRangeId from the courtTypeData
            setDayRangeId(courtTypeData.dayRangeId); // Add this line

            if (pricingData.fromDay === pricingData.toDay) {
              setPricingType('single');
              setSingleDay(pricingData.fromDay.toLowerCase());
            } else {
              setPricingType('range');
              setFromDay(pricingData.fromDay.toLowerCase());
              setToDay(pricingData.toDay.toLowerCase());
            }
          }
          setSelectedSport(sportId);
          setSelectedCourt(String(courtTypeId));

          setIsEditMode(true);
        }
      } catch (error) {
        console.error('Error fetching pricing data:', error);
      }
    };

    fetchPricingData();
  }, [academyId, courtTypeId, sportId, token]);

  useEffect(() => {
    if (!selectedCenter) return;

    const fetchSportsAndCourts = async () => {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      };

      try {
        const response = await fetch(`${process.env.REACT_APP_API_SPORT_COURT_TYPE}?academyIds=${selectedCenter}`, { headers });
        const data = await response.json();
        if (data.success) {
          const sports = data.data_list.map((item) => ({
            value: item.sportId,
            label: item.sportName,
            icon: item.icon,
          }));
          setSports(sports);

          if (selectedSport) {
            const sportData = data.data_list.find(item => item.sportId === Number(selectedSport));
            if (sportData?.CourtTypes) {
              const courtType = Object.entries(sportData.CourtTypes).map(([key, value]) => ({
                value: key,
                label: value,
              }));
              setCourtType(courtType);

              if (isEditMode && courtTypeId) {
                const courtExists = courtType.some(court => court.value === courtTypeId);
                if (courtExists) {
                  setSelectedCourt(courtTypeId);
                }
              }

            } else {
              setCourtType([]);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchSportsAndCourts();
  }, [selectedCenter, selectedSport, isEditMode, courtTypeId, token]);

  useEffect(() => {
    if (isEditMode && courtTypeId && courtType.length > 0) {
      const courtExists = courtType.some(court => court.value === courtTypeId);
      if (courtExists && selectedCourt !== courtTypeId) {
        setSelectedCourt(courtTypeId);
      }
    }
  }, [courtType, isEditMode, courtTypeId, selectedCourt]);

  const handleSportChange = (sportId) => {
    setSelectedSport(sportId);
    setSelectedCourt(null);
    setPricingType('');
    setFromDay('');
    setToDay('');
    setSingleDay('');
    setTimeSlots([{ startTime: '', endTime: '', price: '' }]);
    setIsEditMode(false);
    setOriginalId(null);
    setDayRangeId(null); // Reset dayRangeId when sport changes
  };

  const timeOptions = []
  for (let hour = 0; hour < 24; hour++) {
    const timeString = `${hour.toString().padStart(2, '0')}:00`;
    const hour12 = hour === 0 ? 12 : (hour > 12 ? hour - 12 : hour);
    const ampm = hour < 12 ? 'AM' : 'PM';
    const label = `${hour12}:00 ${ampm}`;

    timeOptions.push({ value: timeString, label });
  }

  const updateTimeSlot = (index, field, value) => {
    setTimeSlots(prev =>
      prev.map((slot, idx) =>
        idx === index ? { ...slot, [field]: value } : slot
      )
    )
  }

  const removeTimeSlot = (indexToRemove) => {
    if (timeSlots.length > 1) {
      setTimeSlots(prev => prev.filter((_, idx) => idx !== indexToRemove))
    }
  }

  const addTimeSlot = () => {
    setTimeSlots(prev => [
      ...prev,
      { startTime: '', endTime: '', price: 0 }
    ])
  }

  const handleSubmit = async () => {
    if (timeSlots.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'Missing Slot',
        text: 'At least one time slot is required.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const parseTime = (timeStr) => {
      const [h, m] = timeStr.split(':').map(Number);
      return h * 60 + m;
    };

    const endToMinutes = (slot) => {
      const s = parseTime(slot.startTime);
      let e = parseTime(slot.endTime);
      if (slot.endTime === '00:00' && s !== 0) e = 24 * 60;
      return e;
    };

    for (let i = 0; i < timeSlots.length; i++) {
      const { startTime, endTime, price } = timeSlots[i];

      if (!startTime || !endTime || price === '' || Number(price) < 0) {
        Swal.fire({
          icon: 'info',
          title: 'Invalid Slot',
          text: `Please fill all fields for slot ${i + 1} correctly.`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      const isMidnightEnd = endTime === '00:00';
      const crossesMidnight = isMidnightEnd && startTime !== '00:00';

      if (!crossesMidnight && startTime >= endTime && !(startTime === '00:00' && endTime === '00:00')) {
        Swal.fire({
          icon: 'info',
          title: 'Time Error',
          text: `Start time should be before end time in slot ${i + 1}.`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
    }

    if (!selectedSport || !selectedCourt) {
      Swal.fire({
        icon: 'info',
        title: 'Selection Required',
        text: 'Please select both Sport and Court before submitting.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    if (pricingType === 'range' && (!fromDay || !toDay)) {
      Swal.fire({
        icon: 'info',
        title: 'Day Selection Required',
        text: 'Please select both From and To days.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    if (pricingType === 'single' && !singleDay) {
      Swal.fire({
        icon: 'info',
        title: 'Day Selection Required',
        text: 'Please select a day.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const sorted = [...timeSlots].sort(
      (a, b) => parseTime(a.startTime) - parseTime(b.startTime)
    );
    for (let i = 0; i < sorted.length - 1; i++) {
      const currentEnd = endToMinutes(sorted[i]);
      const nextStart = parseTime(sorted[i + 1].startTime);
      if (currentEnd > nextStart) {
        Swal.fire({
          icon: 'info',
          title: 'Overlapping Time',
          text: `Slot ${i + 1} overlaps with Slot ${i + 2}. Please adjust the timings.`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
    }

    const cap = (d) => d.charAt(0).toUpperCase() + d.slice(1);
    const from = pricingType === 'single' ? singleDay : fromDay;
    const to = pricingType === 'single' ? singleDay : toDay;

    // Updated payload to include dayRangeId during edit
    const payload = {
      academyId,
      sportId: parseInt(selectedSport, 10),
      courtTypeId: parseInt(selectedCourt, 10),
      fromDay: cap(from),
      toDay: cap(to),
      timeRanges: timeSlots.map((slot) => ({
        startTime: `${slot.startTime}:00`,
        endTime: `${slot.endTime}:00`,
        hourlyPricing: parseFloat(slot.price),
        originalId: slot.originalId || null,
      })),
    };

    if (isEditMode && dayRangeId) {
      payload.dayRangeId = dayRangeId;
      payload.replaceDays = true;
    }

    console.log("Sending data with payload", payload);

    try {
      await axios.post(process.env.REACT_APP_API_COURT_PRICE_SUBMIT, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      Swal.fire({
        icon: 'success',
        title: 'Pricing Saved!',
        text: 'Court Pricing added Successfully.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
      });
      navigate('/courtPricing');
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Save Failed',
        text: err.response?.data?.success_message || err.response?.data?.message || err.message,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const handleCourtChange = (courtId) => {
    setSelectedCourt(courtId);
    setPricingType('');
    setFromDay('');
    setToDay('');
    setSingleDay('');
    setTimeSlots([{ startTime: '', endTime: '', price: '' }]);
    setIsEditMode(false);
    setOriginalId(null);
    setDayRangeId(null); // Reset dayRangeId when court changes
  };

  const handlePricingTypeChange = (type) => {
    setPricingType(type);
    setFromDay('');
    setToDay('');
    setSingleDay('');
    setTimeSlots([{ startTime: '', endTime: '', price: '' }]);
  };

  const handleFromDayChange = (day) => {
    setFromDay(day);
    setToDay('');
    setTimeSlots([{ startTime: '', endTime: '', price: '' }]);
  };

  const handleToDayChange = (day) => {
    setToDay(day);
    setTimeSlots([{ startTime: '', endTime: '', price: '' }]);
  };

  const handleSingleDayChange = (day) => {
    setSingleDay(day);
    setTimeSlots([{ startTime: '', endTime: '', price: '' }]);
  };

  return (
    <div className="enrollment-container">
      {/* Day Selection */}
      <div className="breadcrumb">
        <Link to="/courtPricing" className="breadcrumb-link">
          Court Pricing
        </Link>{" "}
        &gt; {courtTypeId ? "Update Court Pricing" : "New Court Pricing"}
      </div>
      <fieldset className="enrollment-form-fieldset enrollment-form-mt-3">
        {/* Sport Selection */}
        <div>
          <label style={{ color: 'black', margin: '0px', paddingTop: '10px', paddingBottom: '7px' }}>Sport:</label>
          <div className="sport-cards-container">
            {sports.map((sport) => (
              <div
                key={sport.value}
                className={`sport-card ${selectedSport === sport.value ? 'selected' : ''}`}
                onClick={() => handleSportChange(sport.value)}
              >
                <img
                  src={sport.icon}
                  alt={sport.label}
                  style={{ width: '50px', height: '50px', objectFit: 'contain' }}
                />

                <div className="sport-name">{sport.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Court Selection */}
        <div style={{ marginTop: '15px' }}>
          <label style={{ color: 'black', margin: '0px', paddingTop: '10px', paddingBottom: '7px' }}>Court Type:</label>
          <div className="sport-cards-container">
            {selectedSport ? (
              courtType.length > 0 ? (
                courtType.map((court) => (
                  <div
                    key={court.value}
                    className={`sport-card ${selectedCourt === court.value ? 'selected' : ''}`}
                    onClick={() => handleCourtChange(court.value)}
                  >
                    <div className="sport-name">{court.label}</div>
                  </div>

                ))
              ) : (
                <div>No court types available for this sport</div>
              )
            ) : (
              <div>Please select a sport</div>
            )}
          </div>
        </div>

        <legend className="enrollment-form-legend">Time Slots & Pricing</legend>
        <div style={{ marginTop: '15px' }}>
          <label style={{ color: 'black', margin: '0px', paddingTop: '10px', paddingBottom: '7px' }}>Pricing Type:</label>
          <div className="sport-cards-container" style={{ marginBottom: '15px' }}>
            {[
              {
                label: 'Day Range',
                value: 'range',
                icon: '📅',
              },
              {
                label: 'Single Day',
                value: 'single',
                icon: '🗓️',
              }

            ].map((type) => (
              <div
                key={type.value}
                className={`sport-card ${pricingType === type.value ? 'selected' : ''}`}
                onClick={() => handlePricingTypeChange(type.value)}
              >
                <div
                  style={{
                    fontSize: '24px',
                    marginBottom: '6px',
                  }}
                >
                  {type.icon}
                </div>
                <div className="sport-name">{type.label}</div>
              </div>
            ))}
          </div>
        </div>


        {pricingType === 'range' ? (
          <div style={{ marginTop: '15px' }}>
            <label style={{ color: 'black', marginTop: '5px', paddingTop: '10px', paddingBottom: '5px', marginRight: '10px' }}>Days Selection:</label>
            <div className="day-selectors">
              <div className="floating-select" style={{ width: '150px', margin: '0px' }}>
                <Select
                  options={daysOfWeek}
                  value={daysOfWeek.find(o => o.value === fromDay)}
                  onChange={opt => handleFromDayChange(opt.value)}
                  className={`sales-filter-court-booking ${fromDay ? 'has-value' : ''}`}

                  placeholder="From Day"
                  menuPortalTarget={document.body}
                  styles={{
                    placeholder: provided => ({ ...provided, color: 'black' }),
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                  }}

                />
                {fromDay && <label htmlFor="fromDay">From Day</label>}
              </div>
              <div className="floating-select" style={{ width: '150px', margin: '0px' }}>
                <Select
                  options={(() => {
                    const fromIndex = daysOfWeek.findIndex(d => d.value === fromDay);
                    return fromIndex >= 0 ? daysOfWeek.slice(fromIndex + 1) : [];
                  })()}
                  key={fromDay}
                  value={daysOfWeek.find(o => o.value === toDay)}
                  onChange={opt => handleToDayChange(opt.value)}
                  className={`sales-filter-court-booking ${toDay ? 'has-value' : ''}`}

                  placeholder="To Day"
                  menuPortalTarget={document.body}
                  styles={{
                    placeholder: provided => ({ ...provided, color: 'black' }),
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                  }}

                />
                {toDay && <label htmlFor="toDay">To Day</label>}
              </div>
            </div>
          </div>
        ) : (
          <div style={{ display: '-webkit-inline-box', textAlign: 'center' }}>
            <label style={{ color: 'black', display: 'flex', alignItems: 'center', marginRight: '10px' }}>Day Selection:</label>
            <div className="floating-select" style={{ width: '150px', margin: '0px' }}>
              <Select
                options={daysOfWeek}
                value={daysOfWeek.find(o => o.value === singleDay)}
                onChange={opt => handleSingleDayChange(opt.value)}
                className={`sales-filter-court-booking ${singleDay ? 'has-value' : ''}`}
                classNamePrefix="react-select"
                placeholder="Select Day"
                menuPortalTarget={document.body}
                styles={{
                  placeholder: provided => ({ ...provided, color: 'black' }),
                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                }}
              />
              {singleDay && <label htmlFor="singleDay">Day</label>}
            </div>
          </div>
        )}
        <div style={{ marginTop: '15px', overflow: 'scroll' }}>
          <label style={{ color: 'black', marginTop: '5px', paddingTop: '10px', paddingBottom: '5px' }}>Time Selection:</label>
          <table className="rental-entry-table" style={{ marginTop: '10px' }}>
            <thead className="table-head">
              <tr>
                <th className="table-header">Start Time</th>
                <th className="table-header">End Time</th>
                <th className="table-header">Price (₹)</th>
                <th className="table-header">Action</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {timeSlots.map((slot, idx) => (
                <tr key={idx}>
                  <td className="table-cell">
                    <Select
                      options={timeOptions}
                      value={timeOptions.find(o => o.value === slot.startTime)}
                      onChange={opt => updateTimeSlot(idx, 'startTime', opt.value)}
                      className="time-select-react"
                      menuPortalTarget={document.body}
                    />
                  </td>
                  <td className="table-cell">
                    <Select
                      options={timeOptions}
                      value={timeOptions.find(o => o.value === slot.endTime)}
                      onChange={opt => updateTimeSlot(idx, 'endTime', opt.value)}
                      className="time-select-react"
                      menuPortalTarget={document.body}
                    />
                  </td>
                  <td className="table-cell">
                    <input
                      type="number"
                      min="0"
                      step="any"
                      value={slot.price}
                      onChange={e => updateTimeSlot(idx, 'price', e.target.value)}
                      className="enrollment-form-input rental-input"
                      placeholder="0"
                      onWheel={e => e.target.blur()}
                      onKeyDown={e => ['ArrowUp', 'ArrowDown'].includes(e.key) && e.preventDefault()}
                    />
                  </td>

                  <td className="table-cell">
                    <button
                      onClick={() => removeTimeSlot(idx)}
                      disabled={timeSlots.length === 1}
                      className="enrollment-form-button enrollment-form-button-danger"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 7h12M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M10 11v6M14 11v6M5 7h14l-1 12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 7z" />
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button
          type="button"
          className="plusButton"
          onClick={addTimeSlot}
          title="Add Slot"
        >
          <svg className="plusIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
            <g>
              <path d="M13.75 23.75V16.25H6.25V13.75H13.75V6.25H16.25V13.75H23.75V16.25H16.25V23.75H13.75Z"></path>
            </g>
          </svg>
        </button>
      </fieldset>

      <div className="enrollment-form-section enrollment-form-mt-3">
        <button onClick={handleSubmit} className="submit-button">Submit</button>
      </div>
    </div>
  )
}

export default CourtPricing